import {get} from '../../../utils'
import {FC} from 'react'

import {useMapComponents} from '../hooks'

export const useMapComponent = <T>(componentName: string): FC<T> | null => {
  const components = useMapComponents()
  const Component = get(componentName, components)
  if (Component) {
    return Component
  } else {
    return null
  }
}
